export const FEEDBACK_MESSAGE = 'loading';
